import { IconButton } from '@components/button';
import { InstagramLogoIcon } from '@radix-ui/react-icons';
import type { ReactElement } from 'react';
import type { Socials as SocialsType } from 'types/socials';
import { validateString } from 'utils/validate-string';

import styles from './socials.module.scss';

interface Props {
  readonly children?: SocialsType | undefined;
}

const rootClass = validateString(styles.root);
const iconClass = validateString(styles.icon);

export default function Socials({ children }: Props): ReactElement | null {
  if (
    typeof children === 'undefined' ||
    (typeof children.instagram === 'undefined' &&
      typeof children.facebook === 'undefined')
  ) {
    return null;
  }

  const { instagram } = children;

  return (
    <>
      {typeof instagram !== 'undefined' && (
        <a
          aria-label="Instagram profile"
          className={rootClass}
          href={instagram}
        >
          <IconButton aria-label="Instagram profile" role="link">
            <InstagramLogoIcon className={iconClass} height={24} width={24} />
          </IconButton>
        </a>
      )}
    </>
  );
}
